import { render } from "./eproSubjects.vue?vue&type=template&id=f056030a&scoped=true"
import script from "./eproSubjects.js?vue&type=script&lang=js"
export * from "./eproSubjects.js?vue&type=script&lang=js"

import "./eproSubjects.vue?vue&type=style&index=0&id=f056030a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f056030a"]])

export default __exports__